
import { Component, OnInit } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { RouterLink } from '@angular/router';
import { StaticWhyLoveComponent } from '../static-why-love/static-why-love.component';
@Component({
  selector: 'app-why-love-flash',
  imports: [
    CarouselModule,
    StaticWhyLoveComponent
  ], templateUrl: './why-love-flash.component.html',
  styleUrl: './why-love-flash.component.css'
})
export class WhyLoveFlashComponent {


  responsiveOptions: any[] | undefined;

  subjects: any[] =
    [
      {
        name: 'Study More Efficiently',
        icon: 'Icons/flash1.png',
        discrption: "Digital flashcards help you focus on key concepts and revise smarter, not harder."
      },
      {
        name: 'Revise on the go',
        icon: 'Icons/flash2.png',
        discrption: "Study anytime, anywhere. Our digital flashcards fit seamlessly into your busy schedule."
      },

      {
        name: 'Boost exam confidence',
        icon: 'Icons/flash3.png',
        discrption: "Active recall and spaced repetition reinforce knowledge, helping you face exams well-prepared and confident."
      },




    ]


  // ngOnInit(): void {
  //   this.responsiveOptions = [
  //     {
  //         breakpoint: '1400px',
  //         numVisible: 2,
  //         numScroll: 1
  //     },
  //     {
  //         breakpoint: '1199px',
  //         numVisible: 3,
  //         numScroll: 1
  //     },
  //     {
  //         breakpoint: '767px',
  //         numVisible: 2,
  //         numScroll: 1
  //     },
  //     {
  //         breakpoint: '575px',
  //         numVisible: 1,
  //         numScroll: 1
  //     }
  // ]  }

}
